import React, { useEffect, useRef } from 'react';

const MatrixShineCard = ({ children, className = '' }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const rect = canvas.parentElement.getBoundingClientRect();
    
    // Set canvas size
    canvas.width = rect.width;
    canvas.height = rect.height;

    // Matrix characters (law-related symbols)
    const chars = '§¶†‡•◊∞≈≠≤≥÷×±∓∫∑∏√∂∆∇∈∉⊂⊃⊄⊅⊆⊇';
    const fontSize = 14;
    const columns = Math.floor(canvas.width / fontSize);
    
    // Create static matrix pattern
    ctx.fillStyle = 'rgba(212, 175, 55, 0.05)';
    ctx.font = `${fontSize}px monospace`;
    
    for (let i = 0; i < columns; i++) {
      for (let j = 0; j < Math.floor(canvas.height / fontSize); j++) {
        const char = chars[Math.floor(Math.random() * chars.length)];
        const x = i * fontSize;
        const y = j * fontSize;
        const opacity = Math.random() * 0.15 + 0.05;
        ctx.fillStyle = `rgba(212, 175, 55, ${opacity})`;
        ctx.fillText(char, x, y);
      }
    }
  }, []);

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Static Matrix Background */}
      <canvas
        ref={canvasRef}
        className="absolute inset-0 pointer-events-none"
        style={{ opacity: 0.4 }}
      />
      
      {/* Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-[rgba(212,175,55,0.2)] to-[rgba(229,178,0,0.2)]" />
      
      {/* Shine Effect */}
      <div className="shine-effect absolute inset-0 pointer-events-none" />
      
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default MatrixShineCard;
